<template>
  <v-container>
    <v-layout row wrap>
      <v-flex sm12 md3>
        <v-card>
          <v-card-title>
            <span class="title font-weight-light">{{ $t("reports.filter") }}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-flex md12>
                <v-autocomplete
                  name="student_group_id"
                  v-model="search_params.student_group_id"
                  :items="studentgroups"
                  item-text="name"
                  item-value="id"
                  :label="$t('studentgroups.title')"
                  autocomplete="new-password"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex md12>
                <v-autocomplete
                  name="company_id"
                  v-model="search_params.company_id"
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  :label="$t('enrolments.title_org')"
                  autocomplete="new-password"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex md12>
                <v-select
                  v-model="search_params.tenant_user_status"
                  :items="[{ key: 'all', text: $t('global.dd_enrolment_list_status_all') }, ...$dd_user_status()]"
                  item-text="text"
                  item-value="key"
                  :label="$t('users.status')"
                >
                </v-select>
              </v-flex>
            </v-form>
            <v-flex xs12 class="mt-3">
              <action-button type="run_report" :text="$t('data.view_data')" class="ml-0" small @click="filter" />
              <action-button type="reset" @click="reset" small color="error" />
              <action-button type="default" :text="$t('reports.export_to_excel')" icon="get_app" small @click="exportExcel()" />
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex sm12 md9 class="pl-3">
        <v-data-table
          :headers="headers"
          :items="data"
          :items-per-page="data.length"
          :options.sync="pagination"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
            'items-per-page-all-text': $t('global.items_per_page_all_text'),
            'items-per-page-text': $t('global.items_per_page_text'),
            'page-text': $t('global.page_text')
          }"
          :server-items-length="total"
          :loading="show_loading"
          :loading-text="$t('global.loading_text')"
          :no-data-text="$t('global.no_data_text')"
          :no-results-text="$t('global.no_results_text')"
          :must-sort="true"
        >
          <template v-slot:item.company_id="{ item }">
            {{ item.companies ? item.companies.map(i => i.name).join(", ") : "" }}
          </template>

          <template v-slot:item.date_of_birth="{ item }">
            {{ item.date_of_birth ? moment.utc(item.date_of_birth).format(DATE_FORMAT) : null }}
          </template>

          <template v-slot:item.tenant_user_status="{ item }">
            {{ $dd_user_status(item.tenant_user_status) }}
          </template>

          <template v-slot:item.groupcode="{ item }">
            {{ item.student_groups ? item.student_groups.map(i => i.name).join(", ") : "" }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "ExportParticipants",

  data() {
    return {
      first_load: true,
      data: [],
      studentgroups: [],
      companies: [],
      search_params: {},
      url: "",
      data: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: [false]
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("participants.first_name"), value: "first_name" },
          { text: this.$t("participants.last_name"), value: "last_name" },
          { text: this.$t("participants.date_of_birth"), value: "date_of_birth" },
          { text: this.$t("participants.email"), value: "email" },
          { text: this.$t("participants.mobile"), value: "mobile" },
          { text: this.$t("studentgroups.groupcode"), value: "groupcode" },
          { text: this.$t("participants.company_id"), value: "company_id" },
          { text: this.$t("users.status"), value: "tenant_user_status", width: "100px" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh && !this.first_load) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal) && !this.first_load) {
          this.refresh = true
        }
      }
    }
  },

  created() {
    this.ddlist()
  },

  methods: {
    list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.API_URL + "participants?" + query).then((res) => {
        this.data = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },
    ddlist() {
      let lists = [
        { key: "studentgroups", module: "studentgroups", query: "show_all=true" },
        { key: "enrolled_organisations", module: "enrolled_organisations", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.studentgroups = res.data.studentgroups
        this.companies = res.data.enrolled_organisations
      })
    },
    filter() {
      this.first_load = false
      this.refresh = true
    },
    reset() {
      this.data = []
      this.search_params = {}
      this.total = 0
      this.pagination.page = 0
    },
    exportExcel() {
      let params = JSON.parse(JSON.stringify(this.search_params))
      let query = this.$queryString(this.pagination, params)
      query = query.replace("&rows_per_page", "&tmp")

      axios({
        url: this.API_URL + "participants/export?show_all=true&returntype=array&resourcetype=user-basic&" + query,
        method: "POST",
        responseType: "arraybuffer"
      }).then((response) => {
        if (this.$arrayBufferValidation(response.data)) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", "participants_export.xlsx")
          link.click()
        }
      })
    }
  }
}
</script>
